const {
  debug,
  debug: { activate, logger, deactivate, Level, status }
} = window.o_global;

export { Level, activate, deactivate, debug, logger, status };
/*                              */
